import React, { useContext, useState, useRef } from "react";
import { AppContext } from "../../context/AppContext";
import { useNavigate } from "react-router-dom";
import { Autocomplete } from "@react-google-maps/api";

function TowSearch(props) {
  const { searchTowTrucks } = useContext(AppContext);
  let navigate = useNavigate();

const [coordinates, setCoordinates] = useState({ lat: null, lng: null, state: "" });
    const autocompleteRef = useRef(null);
    const [address, setAddress] = useState("");
    const [capacity, setcapacity] = useState("");
    
    
 const onPlaceChanged = () => {
    const place = autocompleteRef.current.getPlace();

    if (place.geometry) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      // Extract state from address_components
      let state = "";
      const addressComponents = place.address_components;
      if (addressComponents) {
        for (let comp of addressComponents) {
          if (comp.types.includes("administrative_area_level_1")) {
            state = comp.long_name;
            break;
          }
        }
      }

      setAddress(place.formatted_address);
      setCoordinates({ lat, lng, state });

      console.log("Selected:", {
        address: place.formatted_address,
        state,
        lat,
        lng,
      });
    }
  };


  return (
    <>
      <div className="module">
        <h3 className="modtitle">Filter </h3>
        <div className="modcontent ">
          <form className="type_2">
            <div className="table_layout filter-shopby">
              <div className="table_row">
                {/* - - - - - - - - - - - - - Category filter - - - - - - - - - - - - - - - - */}
                <div className="table_cell" style={{ zIndex: 103 }}>
                  <legend>Capacity</legend>
                  <input
                      className="form-control grey-border-input"
                      placeholder="e.g., 300lbs, truck capacity"
                      onChange={(event) => setcapacity(event.target.value)}
                    />
                </div>
                <div className="table_cell" style={{ zIndex: 103 }}>
                  <legend>Address</legend>
                      <Autocomplete
        onLoad={(autoC) => (autocompleteRef.current = autoC)}
        onPlaceChanged={onPlaceChanged}
        className="overide"
      >
        <input
          name="address"
          type="text"
          placeholder="Where should the tow truck come?"
          className={[
            "form-control grey-border-input",
            //errors?.address ? " is-invalid" : "",
            
          ].join(" ")}
          value={address}
          onChange={(e) => setAddress(e.target.value)}
        />
      </Autocomplete>
                </div>
       
          </div>
              {/*/ .table_row */}
              <footer className="bottom_box">
                <button
                  type="button"
                  id="sas_search_button0"
                  className="button_grey button_submit"
                  onClick={() => {
                    searchTowTrucks(capacity, address, coordinates?.lat, coordinates?.lng);
                        navigate("../towtrucks", { replace: true });
                  }}
                  style={{ width: "100%" }}
                >
                      Find A Tow Truck
                </button>
                {/*Back To Top*/}
                <div className="back-to-top">
                  <i className="fa fa-angle-up" />
                </div>
              </footer>
            </div>
            {/*/ .table_layout */}
          </form>
        </div>
      </div>
    </>
  );
}

export default TowSearch;
